import { render, staticRenderFns } from "./TRTPageBuilder.vue?vue&type=template&id=247afecc&"
import script from "./TRTPageBuilder.vue?vue&type=script&lang=js&"
export * from "./TRTPageBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports